/** The API's error body (CONVENTIONS.md): `{ error: { code, message, details?, request_id? } }`. */
export interface ApiErrorBody {
  code: string;
  message: string;
  details?: unknown;
  request_id?: string;
}

/**
 * Field messages from a 400 VALIDATION_FAILED: its `details.issues` name each field by path
 * ("location.lat"). A form shows each message under its field; the first one per field wins.
 */
export function fieldErrorsOf(error: ApiErrorBody | null | undefined): Record<string, string> {
  const issues = (error?.details as { issues?: { path?: string; message?: string }[] } | undefined)?.issues;
  const out: Record<string, string> = {};
  for (const issue of issues ?? []) {
    if (issue.path && issue.message && !(issue.path in out)) out[issue.path] = issue.message;
  }
  return out;
}
